// services/facturas.js
import axiosInstance from './axiosInstance';

const FACTURAS_API_URL = '/facturas';

const facturasService = {
  async get(idempresa, filters = {}) {
    try {
      const { start_date, end_date, type, posto, cliente, search, page, pageSize } = filters;
      let url = `${FACTURAS_API_URL}/get.php?idempresa=${idempresa}`;
      
      if (start_date && end_date) {
        url += `&start_date=${start_date}&end_date=${end_date}`;
      }
      if (type) {
        url += `&type=${type}`;
      }
      if (posto) {
        url += `&posto=${posto}`;
      }
      if (cliente) {
        url += `&cliente=${cliente}`;
      }
      if (page) {
        url += `&page=${page}`;
      }
      if (pageSize) {
        url += `&pageSize=${pageSize}`;
      }
      if (search) {
        url += `&search=${search}`;
      }
      const response = await axiosInstance.get(url);
      // A API agora retorna um objeto com stats, entries, page, totalPages, totalItems
      if (response.data === "NOK") {
        return {
          stats: { totalResults: 0, valorLiquido: 0, totalAnulado: 0 },
          entries: [],
          page: 1,
          totalPages: 0,
          totalItems: 0
        };
      }
      // Se for array (formato antigo), converter para novo formato
      if (Array.isArray(response.data)) {
        return {
          stats: { totalResults: response.data.length, valorLiquido: 0, totalAnulado: 0 },
          entries: response.data,
          page: 1,
          totalPages: 1,
          totalItems: response.data.length
        };
      }
      return response.data;
    } catch (error) {
      console.error(error);
      return {
        stats: { totalResults: 0, valorLiquido: 0, totalAnulado: 0 },
        entries: [],
        page: 1,
        totalPages: 0,
        totalItems: 0
      };
    }
  },

  async getById(idempresa, params) {
    try {
      const { type, posto, tpv, serie, numero, date_time } = params;
      let url = `${FACTURAS_API_URL}/getById.php?idempresa=${idempresa}&type=${type}&posto=${posto}&tpv=${tpv}&serie=${serie}&numero=${numero}`;
      
      if (date_time) {
        url += `&date_time=${date_time}`;
      }
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async set(facturaData) {
    try {
      const response = await axiosInstance.post(`${FACTURAS_API_URL}/set.php`, facturaData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unset(idempresa, params) {
    try {
      const { type, posto, tpv, serie, numero, date_time } = params;
      let url = `${FACTURAS_API_URL}/unset.php?idempresa=${idempresa}&type=${type}&posto=${posto}&tpv=${tpv}&serie=${serie}&numero=${numero}`;
      
      if (date_time) {
        url += `&date_time=${date_time}`;
      }
      
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async email(emailData) {
    try {
      const response = await axiosInstance.post(`${FACTURAS_API_URL}/email.php`, emailData);
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      throw error;
    }
  },

  async generateBulkPdf(idempresa, docs, pageType = 'a4', selectedPageType = '1') {
    try {
      const endpoint = pageType === 'a4' ? 'pdf.php' : 'receipt.php';
      
      // Add page_type to each document if not already present
      const docsWithPageType = docs.map(doc => ({
        ...doc,
        page_type: doc.page_type || selectedPageType
      }));
      
      const response = await axiosInstance.post(`${FACTURAS_API_URL}/${endpoint}`, {
        idempresa,
        docs: docsWithPageType
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao gerar PDF em bulk:', error);
      throw error;
    }
  }
};

export default facturasService;
